import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1de68327"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center justify-content-between flex-wrap gap-2" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "docs-intro" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "docs-intro__icon" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "mdi mdi-book-open-page-variant-outline" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { class: "docs-intro__title" }, "Reference library"),
    /*#__PURE__*/_createElementVNode("p", { class: "docs-intro__lead" }, " Open a document to preview it in the viewer, or download a copy for offline use. ")
  ])
], -1))
const _hoisted_3 = { class: "docs-grid" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "docs-card__body" }
const _hoisted_6 = { class: "docs-card__title" }
const _hoisted_7 = { class: "docs-card__desc" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "docs-card__action" }, [
  /*#__PURE__*/_createTextVNode(" View PDF "),
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-arrow-right" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WTitle = _resolveComponent("WTitle")!
  const _component_WSubTitle = _resolveComponent("WSubTitle")!
  const _component_PdfViewer = _resolveComponent("PdfViewer")!
  const _component_PDialog = _resolveComponent("PDialog")!
  const _component_PCard = _resolveComponent("PCard")!

  return (_openBlock(), _createBlock(_component_PCard, { class: "docs-page" }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _createVNode(_component_WTitle, { text: "Documentation" }),
          _createVNode(_component_WSubTitle, { text: "Project requirements, interface specs, and contract references" })
        ])
      ])
    ]),
    content: _withCtx(() => [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("button", {
            key: item.title,
            class: "docs-card",
            type: "button",
            onClick: ($event: any) => (_ctx.openPdf(item.title, item.pdfUrl))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['docs-card__icon', `docs-card__icon--${item.tone}`])
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2)
            ], 2),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(item.description), 1),
              _hoisted_8
            ])
          ], 8, _hoisted_4))
        }), 128))
      ]),
      _createVNode(_component_PDialog, {
        visible: _ctx.showPdfViewer,
        "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showPdfViewer) = $event)),
        header: _ctx.PdfViewerTitle,
        modal: true,
        maximizable: true,
        dismissableMask: true,
        style: _normalizeStyle({ width: 'min(1100px, 96vw)' }),
        contentStyle: { padding: 0, height: 'min(78vh, 820px)', overflow: 'hidden' },
        class: "docs-pdf-dialog"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PdfViewer, {
            pdfUrl: _ctx.pdfUrl,
            title: _ctx.PdfViewerTitle
          }, null, 8, ["pdfUrl", "title"])
        ]),
        _: 1
      }, 8, ["visible", "header", "style", "contentStyle"])
    ]),
    _: 1
  }))
}